<template>
 <div>

                <div class="row col-sm-12">
                  
                  <div class="col-sm-5">
                    <div class="input-group input-daterange"><datepicker value="" format="yyyy-MM-dd" :id="'startprof-'+showname" :bootstrap-styling="true" class="datewidth"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker  value="" format="yyyy-MM-dd" :id="'endprof-'+showname" :bootstrap-styling="true" class="datewidth"></datepicker></div>
                  </div>
                  <div class="col-sm-1">
                     <button class="btn btn-primary btn-sm" @click="getreport()">Search</button>
                  </div>

                  <div class="col-sm-6">Quick Inquiry
                    <b-button-group size="sm">
                    <b-button @click="setdate(1)">Previous day</b-button>
                    <b-button @click="setdate(2)">Today</b-button>
                    <b-button @click="setdate(3)">Last Week</b-button>
                    <b-button @click="setdate(4)">This Week</b-button>
                    <b-button @click="setdate(5)">Last Month</b-button>
                    <b-button  @click="setdate(6)">This Month</b-button>
                    </b-button-group>
                  </div>

                </div>
                 <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                    <table class="table table-bordered table-striped table-hover table-dark" >
                      <thead>
                        <tr>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Option</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Class</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Username</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game</th>
                          <th
                          scope="row"
                  
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Total Bet Amount</th>
                          <th
                          scope="row"
       
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Win/Lost</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Valid Bet Amount</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Type</th>
                          <th
                          scope="row"
             
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Net P/L</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Share %</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Total Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Win/Lost</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Valid Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Actual Settlement</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Shareholder Win %</th>
                        </tr>

                        
                      </thead>
                      <tbody>

                        <tr v-for="indukdata in indukdatas">
                          <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary" disabled>Details</button></td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.username}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.agent_type}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.game}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.total_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.win_lost}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.valid_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.type}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.rebate}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.rebate_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.net_pl}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.share}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.commit_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.commit_win_lost}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.commit_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.actual_settlement}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{indukdata.shareholder_win}}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
                <div style="padding-top:30px;">
                  <div class="b-b b-theme nav-active-theme mb-3">
                     <ul class="nav nav-pills" id="myTabchild">
                        <li class="nav-item">
                        <a 
                        class="nav-link active" 
                        id="reportsa"
                        data-toggle="tab" 
                        href="#childreportsa"
                        role="tab" 
                        aria-controls="home" 
                        aria-selected="true">
                        Direct Inferior Client P/L Report
                      </a>
                    </li>
                     </ul>
                   </div>
                   <div class="tab-content mb-4">
                  <div class="tab-pane fade active show" id="childreportsa" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                     <h3 id="type_exp">Client</h3>
                    
                    <div class="table-responsive">
                    <table ref="childsTableprof" class="table table-bordered table-striped table-hover table-dark v-middle dataTable" id="datatable1" role="grid" aria-describedby="datatable_info"> 
                      <thead>
                        <tr>
                          <th
                          scope="row"
                         
                          class="text-center"
                          style="vertical-align: middle;"
                          >Option</th>
                          <th
                          scope="row"
                         
                          class="text-center"
                          style="vertical-align: middle;"
                          >Class</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Username</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game</th>
                          <th
                          scope="row"
                  
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Total Bet Amount</th>
                          <th
                          scope="row"
       
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Win/Lost</th>
                          <th
                          scope="row"
              
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Valid Bet Amount</th>
                          <th
                          scope="row"
              
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Type</th>
                          <th
                          scope="row"
             
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate Amount</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Net P/L</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Share %</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Total Bet Amount</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Win/Lost</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Valid Bet Amount</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Actual Settlement</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Shareholder Win %</th>
                        </tr>

                 
                      </thead>
                      <tbody>

                        <tr v-for="mydata in mydatas">
                          <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary" @click="getreportbet(mydata.user_id,mydata.username)">Details</button></td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.agent_type}}
                          </td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.username}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.game}}</td>
                           <td class="text-center" style="vertical-align: middle;">{{mydata.total_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.win_lost}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.valid_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.type}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.rebate}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.rebate_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.net_pl}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.share}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.commit_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.commit_win_lost}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.commit_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.actual_settlement}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{mydata.shareholder_win}}</td>
                        </tr>
                      </tbody>
                       <tfoot>
                         <tr>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">
                          </td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_bet_amount}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_win_lost}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_valid_bet}}</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_net_pl}}</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_commit_bet}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_commit_winlost}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_commit_bet}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_actual_setlement}}</td>
                          <td class="text-center" style="vertical-align: middle;">{{total.tot_share_win}}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  </div>
                </div>
                      </div>

                  <div class="tab-pane fade" id="clientsa" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                    <h3>Client </h3>
                    <table class="table table-bordered table-striped table-hover table-dark">
                      <thead>
                        <tr>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Option</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Class</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Username</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game</th>
                          <th
                          scope="row"
                  
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Total Bet Amount</th>
                          <th
                          scope="row"
       
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Win/Lost</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Valid Bet Amount</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Type</th>
                          <th
                          scope="row"
             
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Net P/L</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Share %</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Total Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Win/Lost</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Valid Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Actual Settlement</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Shareholder Win %</th>
                        </tr>

                 
                      </thead>
                      <tbody>

                        <tr>
                          <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary">Details</button></td>
                          <td class="text-center" style="vertical-align: middle;">
                            Top Agent<br/>
                           
                          </td>
                          <td class="text-center" style="vertical-align: middle;">Username</td>
                          <td class="text-center" style="vertical-align: middle;">I , H3 , I3 , VIP_Y1</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">Below</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
                      </div>
                   </div>
                </div>
                </div>

</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters } from "vuex";
    import * as TYPES from "@/store/mutation-types";
    import api from '@/api'


export default {
  name: "clientprofitlossreport",
  props: {
    usid:String,
    showname : String
  },
  data: function() {
    return {
        mydatas : [],
        dataTable:null,
        dataTableAnak:null,
        indukdatas : [],
        activeuser : "",
        activetype : "",
        activeket : "Agent",
    }
  },
  components: {
    Datepicker
  },
  computed: {
   ...mapGetters(["allProfitLossReports","singleUser","allTabs"]),
   getAllProfitLossReports(){
      return this.allProfitLossReports
   },
    getUser(){
      return this.singleUser
   },
    getTabs() {
      return this.allTabs
    },
    total: function(){
    var tot_bet_amount = 0;
    var tot_win_lost = 0;
    var tot_valid_bet = 0;
    var tot_rebate = 0;
    var tot_net_pl = 0;
    var tot_commit_bet = 0;
    var tot_commit_winlost = 0;
    var tot_actual_setlement = 0;
    var tot_share_win = 0;

    return this.mydatas.reduce(function(total, item){

      //debugger;

      tot_bet_amount = tot_bet_amount + parseFloat(item.total_bet_amount);
      tot_win_lost = tot_win_lost + parseFloat(item.win_lost);
      tot_valid_bet = tot_valid_bet + parseFloat(item.valid_bet_amount);
      tot_rebate = tot_rebate + parseFloat(item.rebate_amount);
      tot_net_pl = tot_net_pl + parseFloat(item.net_pl);
      tot_commit_bet = tot_commit_bet + parseFloat(item.commit_bet_amount);
      tot_commit_winlost = tot_commit_winlost + parseFloat(item.commit_win_lost);
      tot_actual_setlement = tot_actual_setlement + parseFloat(item.actual_settlement);
      tot_share_win = tot_share_win + parseFloat(item.shareholder_win);

      total = {
        tot_bet_amount : tot_bet_amount,
        tot_win_lost : tot_win_lost,
        tot_valid_bet : tot_valid_bet,
        tot_rebate : tot_rebate,
        tot_net_pl : tot_net_pl,
        tot_commit_bet : tot_commit_bet,
        tot_commit_winlost : tot_commit_winlost,
        tot_actual_setlement : tot_actual_setlement,
        tot_share_win : tot_share_win
      }
      return total;
     // return total + item.total_bet_amount; 
    },0);
  }
  },
  methods : {
    getreport(theusid='',type=''){

      //let defuser = this.getUser
      let theid = ''
      if (theusid == '' || theusid == '0'){
        theid = this.usid;
       // document.getElementById('type_exp').innerHtml("Agent");
        
      } else {
        theid = theusid;
        //document.getElementById('type_exp').innerHtml("Client");
      }

       let par = {
           id : theid
        }

      this.activeuser = theid;

      var awal = ''+$('#startprof').val()+' 00:00:00';
       var akhir = ''+$('#endprof').val()+' 23:59:59';
      
      var ep = '';
      var ket = '';
      if (type == 0){
        ep = 'agent';
        ket = 'AGENT';
      } else if (type == 1){
        ep = 'client';
        ket = 'CLIENT';
      }

      this.activetype = type;
      this.activeket = ket;

      ep = 'client';
      ket = 'Client';

        api.get(ep+'/profitloss?user_id='+theid).then(({ data }) => {
          

          var myarr = data.data;

          this.indukdatas = [];
          this.mydatas = [];
          
          this.indukdatas.push(myarr);
          var mychilds = myarr.children;

          var filter2 = new Object();

          if (awal != ''){
              Object.assign(filter2, {start_date: awal});
          }

          var childs = mychilds.filter(function(item) {
          for (var key in filter2) {
            var itemTime = new Date(item['start_date']);
            var newawal = new Date(awal);
            var newakhir =  new Date(akhir);
            if (itemTime < newawal || itemTime > newakhir) 
              return false;
            }
          return true;
        });

          
           for (var i = childs.length - 1; i >= 0; i--) {  
                this.mydatas.push(childs[i]);
            }
           // debugger;
          
         })

       /* this.$store.dispatch(TYPES.FETCH_PROFITLOSSREPORT, par).then(() => {
           console.log("dua")
          /*  var myarr = this.getAllProfitLossReports;
          
          this.indukdatas.push(myarr);
          var childs = myarr.children;
          if (childs){
           for (var i = childs.length - 1; i >= 0; i--) {  
                this.mydatas.push(childs[i]);
            }
          }
          debugger;
        });*/

       // this.$store.dispatch(TYPES.FETCH_PROFITLOSSREPORT, par).then(() => {

       // });

       
      //  console.log('cektes1')

        /*var myarr = this.getAllProfitLossReports;
        //console.log('cektes')
        //console.log(myarr)
        //debugger;
        //this.indukdatas.push(myarr); 
        this.indukdatas.push(myarr);
        var childs = myarr.children;
        if (childs){
         for (var i = childs.length - 1; i >= 0; i--) {
              
             
              this.mydatas.push(childs[i]);
          }
        }
        debugger;*/
    },
    getreportbet(theusid='',clientname=''){
      //debugger;
    if (theusid != ''){
      let tab = {
        id: "bet"+this.usid,
        name: "Bet-"+clientname,
        usid : this.usid,
        type : "3"
      }

      let isExists = _.find(this.getTabs, {name: tab.name})
      if(!isExists) {
        this.$store.dispatch(TYPES.CREATE_TAB, tab)
      }
    }
    },
    formatthedate(thedate){
      var daydate = thedate.getDate();
      if (daydate.toString().length == 1) {
         daydate = '0'+daydate;
      }
      var daymonth = thedate.getMonth() + 1;
      if (daymonth.toString().length == 1) {
         daymonth = '0'+daymonth;
      }
     // debugger;
      var yr = thedate.getFullYear();

      var mydate = yr+"-"+daymonth+"-"+daydate;

      return mydate;
    },
    getprevmonth(thedate){
      if(thedate.getMonth) {
          thedate.setMonth(thedate.getMonth() - 1);
        } else {
          thedate.setYear(thedate.getYear() - 1);
          thedate.setMonth(12);
        }
          thedate.setDate(1);
          return thedate;
    },
    getlastdate(y,m){
       return  new Date(y, m +1, 0).getDate();
    },
    setdate(inqtime=''){
       let now = new Date();
       debugger;
       if (inqtime == 1){          
          var defaultDate = now - 1000 * 60 * 60 * 24 * 1;

          defaultDate = new Date(defaultDate);
         // var yesdate = defaultDate.getFullYear() + "-" + (defaultDate.getMonth() + 1) + "-" + defaultDate.getDate();
          var yesdate = this.formatthedate(defaultDate);
          //debugger
          $('#startprof-'+this.showname).val(yesdate);
          $('#endprof-'+this.showname).val(yesdate);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 2) {
          var datenow = this.formatthedate(now);
           $('#startprof-'+this.showname).val(datenow);
          $('#endprof-'+this.showname).val(datenow);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 3){
          var Date1 = now - (14 * 1000 * 60 * 60 * 24 * 1);

          var Date2 = now - (7 * 1000 * 60 * 60 * 24 * 1);

          var startdate = this.formatthedate(new Date(Date1));

          var enddate = this.formatthedate(new Date(Date2));


          //debugger
          $('#startprof-'+this.showname).val(startdate);
          $('#endprof-'+this.showname).val(enddate);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 4){
          var Date1 = now - (7 * 1000 * 60 * 60 * 24 * 1);

          var Date2 = now - (1 * 1000 * 60 * 60 * 24 * 1);

          var startdate = this.formatthedate(new Date(Date1));

          var enddate = this.formatthedate(new Date(Date2));


          //debugger
          $('#startprof-'+this.showname).val(startdate);
          $('#endprof-'+this.showname).val(enddate);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 5){
         let now = new Date();

           var tes = this.getprevmonth(now);

           //var tes2 = this.getprevmonth(now);

           var year = tes.getFullYear();
           var mth = tes.getMonth()+1;
           var mth2 = tes.getMonth();
           var lday = this.getlastdate(year,mth2);

           var date2 = year+"-"+mth+"-"+lday;

           var mydate = new Date(date2);

           var startdate = this.formatthedate(tes);

          var enddate = this.formatthedate(mydate);

          $('#startprof-'+this.showname).val(startdate);
          $('#endprof-'+this.showname).val(enddate);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 6){
          let now = new Date();

          var tes = new Date(now.setDate(1));
           var year = tes.getFullYear();
          var mth = tes.getMonth()+1;
          var mth2 = tes.getMonth();
          var lday = this.getlastdate(year,mth2);

          var date2 = year+"-"+mth+"-"+lday;
          var mydate = new Date(date2);

           var startdate = this.formatthedate(tes);

          var enddate = this.formatthedate(mydate);
          $('#startprof-'+this.showname).val(startdate);
          $('#endprof-'+this.showname).val(enddate);
          this.getreport(this.activeuser,this.activetype);
       }
       //debugger;
    }
  },
  mounted(){
    //this.getreport();
    this.dataTableAnak = $(this.$refs.childsTableprof).DataTable({});
    setTimeout(() => this.mydatas = fakeData(50), 1000);
  },
  watch: {
  mydatas(val) {
    this.dataTableAnak.destroy();
    this.$nextTick(() => {
      this.dataTableAnak = $(this.$refs.childsTableprof).DataTable()
    });
  }
},
}
</script>